<script lang="ts" setup>
import { iconLibrary, type IconName } from '@assets/svgLibrary';

const props = defineProps<{
    name: IconName;
    alt?: string;
    class?: string | object | Array<string | object>;
}>();
</script>

<template>
    <span>
        <span class="sr-only">{{ props.alt }}</span>

        <component :is="iconLibrary[props.name]" :class="props.class" />
    </span>
</template>
